import React from 'react';
import { FiActivity, FiCast, FiMap } from "react-icons/fi";
import { Link } from "react-router-dom";
import ScrollAnimation from "react-animate-on-scroll";
import { PiGameControllerLight, } from "react-icons/pi";
import { TbDeviceImacHeart, TbDeviceIpadCode, TbDeviceIpadHorizontalCode } from "react-icons/tb";
import { MdDevicesOther } from "react-icons/md"
import { PiAndroidLogo } from "react-icons/pi";

import './style.css'

const ServiceList = [
    {
        icon: <TbDeviceImacHeart />,
        title: 'Digital Marketing & SEO',
        description: 'We craft result-driven strategies to boost your visibility and drive targeted traffic.',
        url: '/our-services/digital-marketing/seo/',
    },
    {
        icon: <TbDeviceIpadHorizontalCode />,
        title: 'Web Development',
        description: 'We build high-performing, scalable websites using modern frameworks and best practices.',
        url: '/our-services/web-development/full-stack-development-with-next-js/',
    },
    {
        icon: <PiAndroidLogo />,
        title: 'Mobile App Development',
        description: 'We deliver powerful, intuitive mobile apps tailored to meet your business goals.',
        url: '/our-services/mobile-app-solutions/mobile-app-development/',
    },
    {
        icon: <TbDeviceIpadCode />,
        title: 'Software Development',
        description: 'We develop reliable, high-quality software solutions for desktop and mobile platforms.',
        url: '/our-services/web-development/dotnet-development/',
    },
    {
        icon: <PiGameControllerLight />,
        title: 'Game Development',
        description: 'We create captivating games with smooth performance across mobile, web, and PC.',
        url: '/our-services/game-development/game-development/',
    },
    {
        icon: <FiMap />,
        title: 'AI/ML Solutions',
        description: 'We build smart AI/ML solutions that automate tasks and drive smarter decisions.',
        url: '/our-services/ai-ml-solutions/ai-ml-solutions/',
    },
]


const ServiceOne = ({ textAlign, serviceStyle }) => {
    return (
        <div className="row row--15 service-wrapper">
            {ServiceList.map((val, i) => (
                <div className="col-lg-4 col-md-6 col-sm-6 col-12" key={i}>
                    <ScrollAnimation
                        animateIn="fadeInUp"
                        animateOut="fadeInOut"
                        animateOnce={true}>
                        <Link to={val.url}>
                            <div className={`service custom_service_ ${serviceStyle} ${textAlign}`} style={{ height: '34rem' }}>
                                <div className="icon">
                                    {val.icon}
                                </div>
                                <div className="content">
                                    <h4 className="title w-600">{val.title}</h4>
                                    <p className="description b1 color-gray mb--0" dangerouslySetInnerHTML={{ __html: val.description }}></p>
                                </div>
                            </div>
                        </Link>
                    </ScrollAnimation>
                </div>
            ))}
        </div>
    )
}
export default ServiceOne;